diy.angular.registerFactory('diyfmunsortedmodel', [ 
    'diyfmfoldermodel',
    'diyfmconststorage',
function(
    diyfmfoldermodel,
    diyfmconststorage
){
    
    // constructor
    var diyfmunsortedmodel = function (title) {
        diyfmfoldermodel.apply(this, [{
            id: null,
            type: diyfmconststorage
        }, title, {}]); //call parent constructor
    };
    
    // UnsortedFolderSubsection extends FolderSubsection
    diyfmunsortedmodel.prototype = Object.create(diyfmfoldermodel.prototype);
    
    // public methods
    angular.extend(diyfmunsortedmodel.prototype, {
        isNew: function() {
            return false;
        },
        setTitle: function(newTitle) {
            throw new Error("Can't change title for this");
        },

        getActions: function() {
            return this._emptyActions;
        },
        
        getDefaultParams: function()
        {
            return {
                folderId: 0 /* Unsorted virtual folder should provide 0 */
            }
        }
    });
    return diyfmunsortedmodel;
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/models/diyfmunsortedmodel.js
 ** module id = 956
 ** module chunks = 0
 **/